import { NAME } from './reducer'

export const getMap = (id) => (state) => state[NAME].map[id]
export const getView = (id) => (state) => state[NAME].view[id]
export const getLegendLayer = (mapId) => (state) => state[NAME].legendLayer[mapId]
export const getSearchResultsLayer = (mapId) => (state) => state[NAME].searchLayer[mapId]

export const getAllViews = (state) => Object.values(state[NAME].view).filter(a => a) // must have a value

export const getSelectedParcels = (state) => state[NAME].selectedParcels